// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zgxa","col":"styles_col__3n47y"};